var _defs, _path, _path2, _path3, _path4, _circle, _circle2, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIClareRgb(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "i-clare-rgb_svg__Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "39 33 112 114"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".i-clare-rgb_svg__cls-1,.i-clare-rgb_svg__cls-2{fill:none;stroke:#64a70b;stroke-linecap:round;stroke-linejoin:round;stroke-width:4px}.i-clare-rgb_svg__cls-2{fill-rule:evenodd}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "i-clare-rgb_svg__cls-2",
    d: "M107.66 86.38s2.19-.09 4.55.78M136.23 104.92c3.21 4.35 5.12 9.79 5.12 15.68 0 14.33-11.29 25.94-25.21 25.94-2.98 0-5.83-.53-8.49-1.51"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "i-clare-rgb_svg__cls-1",
    d: "M107.23 136.71V150M77.38 150v-13.29"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "i-clare-rgb_svg__cls-2",
    d: "M55.73 91.12c-2.67-.39-7.09 1.1-7.08 8.27.01 7.43 6.2 13.82 10.13 12.95 2.22 8.11 5.14 12.48 7.38 14.96 4.29 4.75 8.75 9.05 17.56 11.34 2.24 2.25 4.87 3.6 8.59 3.63 0 .02.24.02.26.02 3.7-.51 6.09-1.4 8.34-3.65 8.81-2.28 13.27-6.58 17.56-11.34 2.29-2.53 5.29-7.03 7.52-15.48.25.26.53.45.86.52 3.92.89 10.13-5.51 10.14-12.95.01-7.44-4.76-8.78-7.38-8.23-.26.05-.49.13-.73.2M77.19 86.38s-2.19-.09-4.55.78"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "i-clare-rgb_svg__cls-2",
    d: "M92.31 62.91c8.91 14.7 23.93 19.63 37.14 27.06C135.5 61.43 124.84 40.4 93.08 40c-31.76-.41-43.11 25.71-37.99 50.12 2.52-.55 32.15-16.52 37.22-27.21zM92.1 129.53c-3.92-.26-5.2-3.95-7.95-7.14 2.72.2 5.46.79 8.16.99 2.7-.2 5.44-.79 8.16-.99-2.75 3.19-4.45 6.88-8.37 7.14zM88.04 97.15c-5.41-2.76-11.13-5.77-21.35-5.77-7.9 0-5.29 1.36-3.43 12.09 1 5.79 4.17 8.02 13.11 8.54 8.94.52 11.29-4.17 12.85-10.29.68-2.66-.68-4.3-1.19-4.56zM95.39 101.7c1.56 6.13 3.91 10.81 12.85 10.29 8.94-.52 12.11-2.75 13.11-8.54 1.86-10.72 4.47-12.08-3.43-12.09-10.22 0-15.93 3.01-21.35 5.77-.51.26-1.87 1.9-1.19 4.56z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "i-clare-rgb_svg__cls-1",
    cx: 75.65,
    cy: 100.41,
    r: 0.91
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "i-clare-rgb_svg__cls-1",
    cx: 109.04,
    cy: 100.41,
    r: 0.91
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "i-clare-rgb_svg__cls-2",
    d: "M89.38 99.95c.24-.53 2.06-.9 2.67-.9h.1c.61 0 2.42.37 2.67.9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "i-clare-rgb_svg__cls-1",
    d: "M102.48 121.52l-3.51 1.75M81.78 121.52l3.51 1.75"
  })));
}
export default SvgIClareRgb;